import { StringParam, useQueryParam, withDefault } from 'use-query-params'

export enum HomeListType {
  DRAFT = 'DRAFT',
  UNAPPROVED = 'UNAPPROVED',
  APPROVED = 'APPROVED',
  CREATED = 'CREATED',
}

export const useTypeParam = () =>
  useQueryParam('type', withDefault(StringParam, HomeListType.DRAFT))
